import { useSelector } from 'react-redux';
import { selectAccessToken } from '../../../store/auth/auth.selector';
import MainLogo from '../../ui/main-logo/main-logo.component';
import UserBox from '../../ui/user-box/user-box.component';
import { AppBar, ToolBar } from './top-bar.styles';

const TopBar = () => {
    const accessToken = useSelector(selectAccessToken);

    return (
        <AppBar position="static">
            <ToolBar>
                <MainLogo variant="white" />
                {accessToken && <UserBox />}
            </ToolBar>
        </AppBar>
    );
};

export default TopBar;
